"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Destination-specific API calls
var DestinationService = exports.DestinationService = function () {
    function DestinationService(winresCloudService) {
        _classCallCheck(this, DestinationService);

        this.winresCloudService = winresCloudService;
    }

    _createClass(DestinationService, [{
        key: "getWinresDestination",
        value: function getWinresDestination(destinationCode, language) {
            return this.winresCloudService.makeAuthenticatedRequest('GetWinresDestination', {
                "DestinationCode": destinationCode,
                "Language": language
            }, true);
        }
    }, {
        key: "autocompleteDestination",
        value: function autocompleteDestination(keyword) {
            return this.winresCloudService.makeAuthenticatedRequest('AutocompleteDestination', {
                "Keyword": keyword
            });
        }
    }, {
        key: "getMapDestinations",
        value: function getMapDestinations(OnlyFutureDepartures, language) {
            return this.winresCloudService.makeAuthenticatedRequest('GetMapDestinations', {
                "OnlyFutureDepartures": OnlyFutureDepartures,
                "Language": language
            });
        }
    }]);

    return DestinationService;
}();

DestinationService.$inject = ['winresCloudService'];


//////////////////
// WEBPACK FOOTER
// ./src/winresCloud/destinationService.js
// module id = 559
// module chunks = 2